<div class="section" [class.active]="isActive()" [class.active-more-action]="isShowMoreActionState()">
    <div [id]="entity().id" [attr.data-raw-id]="entity().id">
        <div
            class="specific-section-wrap"
            [style.--specific-section-bg]="bg()"
            [style.--specific-section-bg-position]="bgPosition()"
            [style.--specific-section-bg-repeat]="bgRepeat()"
            [style.--specific-section-bg-size]="bgSize()"
        >
            <div
                class="specific-section-inner"
                [class]="sectionInnerClasses()"
                [style.--specific-section-max-width]="maxWidth()"
                [style.--specific-section-align-items]="alignItems()"
                [style.--specific-section-gap]="gap()"
                [style.--specific-section-gap-half]="gapHalf()"
                [style.--specific-section-slot-margin-half]="slotMarginHalf()"
                [style.--specific-section-padding-top]="paddingTop()"
                [style.--specific-section-padding-bottom]="paddingBottom()"
                [style.--specific-section-padding-right]="paddingRight()"
                [style.--specific-section-padding-left]="paddingLeft()"
                [style.--specific-section-mobile-text-align]="mobileTextAlign()"
            >
                @for (column of columns(); track column.id; let i = $index) {
                    @let nextColumn = columns()[i + 1];

                    <div
                        class="column-container"
                        [class]="getColumnClasses(column)"
                        [attr.data-column-width]="columnWidthLabel(column)"
                    >
                        <web-specific-column
                            [index]="i"
                            [entity]="column"
                            [parentEntity]="entity()"
                            [parentEntityIndex]="index()"
                            [block]="parentEntity()"
                            [blockHasLogo]="blockHasLogo()"
                            [disableColumnCopy]="columnsCountReachedMax()"
                        />
                        @if (columnCount() !== i + 1 && columnCount() < 5) {
                            <web-column-resize
                                [columnLeft]="column"
                                [columnRight]="nextColumn"
                                [columnGap]="sectionColumnGap()"
                                (changeWidthToLeftEvent)="changeColumnWidthToLeft(column, nextColumn)"
                                (changeWidthToRightEvent)="changeColumnWidthToRight(column, nextColumn)"
                            />
                        }
                    </div>
                }
            </div>
        </div>

        @if (hideControls()) {
            <web-specific-section-controls
                class="block-controls"
                [hideMoveUp]="isFirst()"
                [hideMoveDown]="isLast()"
                [disableDeleteEvent]="disableDeleteEvent()"
                [disableDeleteEventTooltip]="'disable_remove_row_hint' | translate"
                (selectEvent)="selectSection()"
                (addSection)="addSection()"
                (moveUpEvent)="moveUp()"
                (moveDownEvent)="moveDown()"
                (deleteEvent)="removeSection()"
                (toggleMoreActionState)="setMoreActionState($event)"
            />
        }
    </div>
</div>
